export default "__VITE_ASSET__D00Y2WpQ__"